import React, { useState } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './join-15b17329.js';
import { g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n\n  margin: ", ";\n\n  width: ", ";\n  height: ", ";\n\n  background: ", ";\n  border-radius: ", ";\n  left: 0px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleBox = styled.span(_templateObject(), function (_ref) {
  var sized = _ref.sized,
      theme = _ref.theme;
  return getSpacesAsCss(theme.components.toggle.sizes[sized].spaces);
}, function (_ref2) {
  var sized = _ref2.sized,
      theme = _ref2.theme;
  return theme.components.toggle.sizes[sized].widthEllipse;
}, function (_ref3) {
  var sized = _ref3.sized,
      theme = _ref3.theme;
  return theme.components.toggle.sizes[sized].heightEllipse;
}, function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return theme.components.toggle.colors[variant].backgroundEllipse;
}, function (_ref5) {
  var sized = _ref5.sized,
      theme = _ref5.theme;
  return theme.components.toggle.sizes[sized].borderRadius;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0px;\n  opacity: 0;\n\n  margin: 0;\n  z-index: 2;\n\n  width: ", ";\n  height: ", ";\n\n  cursor: pointer;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var HiddenInputToggle = styled.input(_templateObject$1(), function (_ref) {
  var sized = _ref.sized,
      theme = _ref.theme;
  return theme.components.toggle.sizes[sized].widthRectangle;
}, function (_ref2) {
  var sized = _ref2.sized,
      theme = _ref2.theme;
  return theme.components.toggle.sizes[sized].heightRectangle;
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  width: ", ";\n  height: ", ";\n\n  margin-top: ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n\n  @keyframes slideRight {\n    from {left: 0px;}\n    to {left: ", ";}\n  }\n  @keyframes slideLeft {\n    from {left: ", ";}\n    to {left: 0px;}\n  }\n  \n  ", ":checked + ", " {\n    \n    animation-name: slideRight;\n    animation-duration: 75ms;\n    animation-timing-function: ease-in;\n    left: ", ";\n    background-color:  ", ";\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n\n    &:after {\n      display: inline-block;\n      visibility: visible;\n    }\n  }\n\n\n  ", " + ", "{\n    animation-name: slideLeft;\n    animation-duration: 75ms;\n    animation-timing-function: ease-in;\n    left: 0px;\n  }\n\n  ", " {\n    display: ", ";\n  }\n  \n  \n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ToggleBoxContainer = styled.span(_templateObject$2(), function (_ref) {
  var sized = _ref.sized,
      theme = _ref.theme;
  return theme.components.toggle.sizes[sized].widthRectangle;
}, function (_ref2) {
  var sized = _ref2.sized,
      theme = _ref2.theme;
  return theme.components.toggle.sizes[sized].heightRectangle;
}, function (_ref3) {
  var sized = _ref3.sized,
      theme = _ref3.theme;
  return theme.components.toggle.sizes[sized].margintop;
}, function (_ref4) {
  var variant = _ref4.variant,
      checked = _ref4.checked,
      theme = _ref4.theme;
  return checked ? theme.components.toggle.colors[variant].backgroundRectangleAfter : theme.components.toggle.colors[variant].backgroundRectangle;
}, function (_ref5) {
  var sized = _ref5.sized,
      theme = _ref5.theme;
  return theme.components.toggle.sizes[sized].borderRadius;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.toggle.sizes.left;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.toggle.sizes.left;
}, HiddenInputToggle, ToggleBox, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.toggle.sizes.left;
}, function (_ref9) {
  var variant = _ref9.variant,
      theme = _ref9.theme;
  return theme.components.toggle.colors[variant].backgroundEllipseAfter;
}, HiddenInputToggle, ToggleBox, HiddenInputToggle, function (_ref10) {
  var click = _ref10.click,
      theme = _ref10.theme;
  return theme.components.toggle.display[click].display;
});

function _templateObject$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A toggle button.
 */

var Toggle = function Toggle(_ref) {
  var propsChecked = _ref.checked,
      onChange = _ref.onChange,
      variant = _ref.variant,
      click = _ref.click,
      sized = _ref.sized;

  var _useState = useState(propsChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var handleToggleChecked = function handleToggleChecked() {
    setChecked(!checked);
    onChange && onChange();
  };

  return React.createElement(ToggleBoxContainer, {
    variant: variant,
    click: click,
    sized: sized,
    checked: checked
  }, React.createElement(HiddenInputToggle, {
    checked: checked,
    onChange: handleToggleChecked,
    type: "checkbox",
    sized: sized
  }), React.createElement(ToggleBox, {
    variant: variant,
    sized: sized
  }));
};

Toggle.defaultProps = {
  checked: false,
  onChange: null,
  variant: 'primary',
  click: true,
  sized: 'large'
};
Toggle.propTypes = {
  /**
   * Whether or not the toggle is checked.
   */
  checked: PropTypes.bool,

  /**
   * Gets called when the value of the toggle changes.
   *
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onChange: PropTypes.func,

  /**
   * The type of variation to display.
   */
  variant: PropTypes.oneOf(['primary', 'neutral', 'disabled', 'on_off']),

  /**
   * Click possible or not on the toggle.
   */
  click: PropTypes.bool,

  /**
   * The type of size to display.
   */
  sized: PropTypes.oneOf(['small', 'medium', 'large'])
};
/** @component */

var index = styled(Toggle)(_templateObject$3());

export default index;
